export type ZLayer = "modal" | "popover" | "dropdown" | "tooltip";
export function toZIndex(layer: ZLayer): number {
  switch (layer) {
    case "modal":
      return 10000; // very high numbers since we're "competing" with material ui
    case "popover":
    case "dropdown":
      return 11000;
    case "tooltip":
      return 12000;
  }
}
